exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar-secondary .badge{vertical-align:text-top}", ""]);

// exports
